import React, { Component } from 'react';
import Overview from '../components/Overview';
import TestInstanceStart from './TestInstanceStart';

class TestInstanceOverview extends Component {
    render() {
        const {
            comments,
            name,
            overviewList,
            updateComments,
            id,
            deviceListDisplay,
            startStopInstance,
            startStopTest,
            displayButton,
            refreshDeviceList
        } = this.props;

        return (
            <div className="test-instance-overview pull-right">
                <Overview
                    name={name}
                    comments={comments}
                    overviewList={overviewList}
                    updateComments={updateComments}
                    testInstanceId={id}
                />

                <TestInstanceStart
                    id={id}
                    deviceListDisplay={deviceListDisplay}
                    startStopInstance={startStopInstance}
                    startStopTest={startStopTest}
                    displayButton={displayButton}
                    refreshDeviceList={refreshDeviceList}
                />
            </div>
        )
    }
}

export default TestInstanceOverview;